import { Component, ViewChild, TemplateRef, ElementRef, EventEmitter, Output, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { AuService } from '../au.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-au-participants',
  templateUrl: './au-participants.component.html',
  styleUrls: ['./au-participants.component.scss']
})
export class AuParticipantsComponent implements OnDestroy, OnInit {

  isProcessing = true;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  makeStickyColumns: any;
  auParticipantsDataForGrid: any = [];
  auParticipantsDataForGridTemp: any = [];
  getOneQmsUsersVwDetailsTableData: any = [];
  dropDownForDesignationCode: any = [];
  dropDownForDepartmentCode: any = [];
  columnLists: any = {};
  dataTypeList: any = [];
  dropDownForRole: any = [];
  searchText: any;
  searchValue: any;
  showingRowsText = "Showing rows";
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  dateCustomClasses: DatepickerDateCustomClasses[];
  roleDropdownTxt: any;
  designationCodeTxt: any;
  departmentCodeTxt: any;

  isRoleOdd: any;
  @Output() refreshed = new EventEmitter<{ grid: any }>();


  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, public message: messageService,
    private readonly elem: ElementRef, public qmsservice: qmsService, public paginationService: PaginationService,
    public auService: AuService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  ngOnInit() {
    this.getcallMethod();
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');

    this.appService.getCodeListsByGroup("ROLE_CODE").subscribe((response: any) => {
      this.dropDownForRole = response;
      this.selectBoxForRole();
    })
    this.selectBoxForDesignationCode();
    this.selectBoxForDepartmentCode();
  }

  ngOnDestroy(): void {
    this.refreshed.emit(this.auParticipantsDataForGrid);
  }

  getPrivilege(): boolean {

    const x: string = this.qmsservice.activity.status;

    return this.auService.isAuditor && (
      x == 'Received Q&A Response' || x == 'Auditor Requested More Info. On Q&A Responses' ||
      x == 'In Progress/Q&A pending' || x == 'In Progress/Received Q&A Response' ||
      x == 'In Progress/Auditor Requested More Info. On Q&A Responses' ||
      x == 'In Progress/Received Q&A Response' || x == 'In Progress' ||
      x == 'Findings In Progress' || x == 'Pending Peer Review' ||
      x == 'Peer Review Rejected' || x == 'Peer Reviewer Requested More Info' ||
      x == 'Pending Auditee Review' || x == 'Auditee Requested More Info' ||
      x == 'Closure Approver Requested More Info' || x == 'Closure Reviewer Requested More Info' ||
      x == 'Closure Review Rejected' || x == 'Closure Approval Rejected');
  }

  getcallMethod() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "AU_PARTICIPANTS",
      groupId: 0
    }

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_AU_PARTICIPANTS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          auNoFromAu: this.message.activityId,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.auParticipantsDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }
                for (const row of this.auParticipantsDataForGrid) {
                  for (const element of this.dataTypeList) {
                    if (element.fieldType == 'CHECKBOX') {
                      row[element.columnName] = row[element.columnName] == "Y";
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
                this.labelcall();
              }
            });
            this.message.gridList = this.auParticipantsDataForGrid;
            this.collectionSize = this.auParticipantsDataForGrid.length;
            this.totalPages = Math.ceil(this.auParticipantsDataForGrid.length / this.itemsPerPage);
            this.isProcessing = false;
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.dynamicLabel = null;
    this.label = [];
    this.dynamicLabel = null;
    this.isProcessing = true;
    let data = {
      gridName: this.reportObj.gridName,
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.qmsservice.moduleName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        console.log(this.dynamicLabel);
        this.isProcessing = false;
        return this.dynamicLabel
      },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.auParticipantsDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.auParticipantsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.auParticipantsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.auParticipantsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }


  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.auParticipantsDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.auParticipantsDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.auParticipantsDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.auParticipantsDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.auParticipantsDataForGridTemp = this.auParticipantsDataForGrid;
      this.pager = this.paginationService.getPager(this.auParticipantsDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.auParticipantsDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.auParticipantsDataForGrid == undefined) {
        return this.auParticipantsDataForGrid;
      }
      if (!this.auParticipantsDataForGrid.length) {
        return this.auParticipantsDataForGrid;
      }
      if (filter) {
        this.auParticipantsDataForGridTemp = this.auParticipantsDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.auParticipantsDataForGridTemp = this.auParticipantsDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.auParticipantsDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.auParticipantsDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.auParticipantsDataForGrid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.PARTICIPANT_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.auParticipantsDataForGrid.some((list: any) => list.childCheckBoxs);
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.getcallMethod();
  }

  qmsAuParticipantsFieldData: any = {};
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('searchParticipantName', { static: true }) searchParticipantName: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchParticipantNamePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: '300px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  participantPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  selectedRole: any = [];
  roleDropdown: any = [];

  onRoleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {

        if (this.roleFieldValue != undefined) {
          this.roleFieldValue.style.color = '';
        }
      } else {
        this.roleFieldValue = document.getElementById('role-validation') as HTMLInputElement;
        if (this.roleFieldValue != undefined) {
          this.roleFieldValue.style.color = 'red';
        }
      }
    }
  }

  onRoleRemoved(item: any) {
    this.roleFieldValue = document.getElementById('role-validation') as HTMLInputElement;
    if (this.roleFieldValue != undefined) {
      this.roleFieldValue.style.color = 'red';
    }
  };

  selectBoxForRole() {
    this.roleDropdown = [];
    for (const element of this.dropDownForRole) {
      this.roleDropdown = this.roleDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  selectBoxForDesignationCode() {
    for (const element of this.dropDownForDesignationCode) {
      this.designationCodeDropdown = this.designationCodeDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  selectBoxForDepartmentCode() {
    for (const element of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  onIsApplicationUserChecked(event: any) {
    if (!event.checked || event.checked) {
      this.qmsAuParticipantsFieldData.participantName = '';
    }
  }

  onIsPrimaryContactChecked(event: any) {
    if (event.checked) {
      this.qmsAuParticipantsFieldData.isApplicationUser = true;
    } else {
      this.qmsAuParticipantsFieldData.contactDetails = '';
    }
    if (!this.qmsAuParticipantsFieldData.isApplicationUser) {
      this.qmsAuParticipantsFieldData.participantName = '';
      this.qmsAuParticipantsFieldData.applicationUserId = null;
    }

  }

  showUserSearchGrid: boolean;
  searchByUserName: any;
  searchByFirstName: any;
  searchByLastName: any;
  searchByemailAddress: any;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  opensSearchParticipantNamePopup() {
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.popupTitle = "Search Participant";
    this.primaryauditeeList = [];
    this.appService.getQmsActiveGroupUsers(this.qmsservice.activity.groupId, this.qmsservice.moduleName, "Primary Auditee").subscribe((data: any) => {
      this.primaryauditeeList = data?.sort((m: { userName: string; }, n: { userName: string; }) => m.userName.trim().localeCompare(n.userName.trim()));;
    });
    this.privvalue = null;
    this.visibleSearchParticipantNamePopup = this.dialog.open(this.searchParticipantName, this.participantPopupConfig);
  }
  toggle(event: MatSlideToggleChange) {
    console.log('toggle', event.checked);
    if (event.checked) {
      this.getOneQmsUsersVwDetailsTableData = [];
    } else {
      for (const element of this.primaryauditeeList) {
        element.participantChildCheckBox = false;
      }
    }
  }
  primaryauditeeList: any = [];
  isprimaryauditee: boolean = false;
  searchParticipantGridDataFunction() {
    this.isProcessing = true;
    let data = {
      userName: this.searchByUserName == null ? "" : this.searchByUserName.toUpperCase(),
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByemailAddress,
      designationCode: this.searchByDesignationCode ?? null,
      departmentCode: this.searchByDepartmentCode ?? null,
      status: "active"
    };
    this.isprimaryauditee = false;
    this.appService.getOneQmsUsersVwDetails(data).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  getAapplicationUserId: any;
  getParticipantName: string;
  privvalue: any = null;

  searchParticipantsChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      if (this.privvalue != null && this.privvalue !== undefined) {
        if (!this.isprimaryauditee) {
          if (this.getOneQmsUsersVwDetailsTableData[this.privvalue]) {
            this.getOneQmsUsersVwDetailsTableData[this.privvalue].userChildCheckBox = false;
          }
        } else if (this.getOneQmsUsersVwDetailsTableData[this.privvalue]) {
          this.getOneQmsUsersVwDetailsTableData[this.privvalue].userChildCheckBox = false;
        }
      }
      if (this.isprimaryauditee) {
        listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      } else {
        listOfUsersVwDetails.userChildCheckBox = true;
      }
      this.getAapplicationUserId = listOfUsersVwDetails.userId;
      this.getParticipantName = this.isprimaryauditee ? listOfUsersVwDetails.userName : listOfUsersVwDetails.userFullName;
      this.privvalue = idx;

    } else {
      if (this.isprimaryauditee) {
        listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      } else {
        listOfUsersVwDetails.userChildCheckBox = false;
      }
      this.getAapplicationUserId = null;
      this.getParticipantName = '';
      this.privvalue = null;
    }
  }


  addParticipantNameFunction() {
    this.qmsAuParticipantsFieldData.applicationUserId = this.getAapplicationUserId;
    this.qmsAuParticipantsFieldData.participantName = this.getParticipantName;
    if (this.operationFlag == 'ADD') {
      this.popupTitle = this.popupTitle == "Search Participant" ? "Create Audit Participants" : "";
    } else {
      this.popupTitle = this.popupTitle == "Search Participant" ? "Update Audit Participants" : "";
    }
    this.visibleSearchParticipantNamePopup.close();
  }

  cancelSearchParticipantNamePopup() {
    if (this.operationFlag == 'ADD') {
      this.popupTitle = this.popupTitle == "Search Participant" ? "Create Audit Participants" : "";
    } else {
      this.popupTitle = this.popupTitle == "Search Participant" ? "Update Audit Participants" : "";
    }
    this.visibleSearchParticipantNamePopup.close();
  }

  resetSearchParticipantGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.showUserSearchGrid = false;
    this.isProcessing = false;
    this.isprimaryauditee = false;
    this.getOneQmsUsersVwDetailsTableData = [];
  }

  popupTitle: any;
  visibleEditButton: boolean;
  operationFlag: any;
  openAddPopup() {
    this.operationFlag = 'ADD';
    this.operationMode = "ADD";
    this.popupTitle = "Create Audit Participants";
    this.visibleEditButton = true;
    this.selectedRole = null;
    this.isRoleOdd = null;
    this.qmsAuParticipantsFieldData.participantName = '';
    this.qmsAuParticipantsFieldData.applicationUserId = null;
    this.qmsAuParticipantsFieldData.isApplicationUser = false;
    this.qmsAuParticipantsFieldData.emailAddress = '';
    this.qmsAuParticipantsFieldData.isPrimaryContact = false;
    this.qmsAuParticipantsFieldData.contactDetails = '';
    this.qmsAuParticipantsFieldData.sendNotifications = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingParticipantId: any;
  operationMode: any;
  openEditPopup(auParticipantEditingData: any, index: any, mode: any) {

    this.operationMode = mode;

    if (index == 0) {
      this.isProcessing = true;
      this.operationFlag = 'EDIT';
      this.popupTitle = "Update Audit Participants";
      this.visibleEditButton = false;
      this.editingParticipantId = auParticipantEditingData.PARTICIPANT_ID;
      this.appService.getAuParticipantByPartcipantId(this.editingParticipantId).subscribe((data: any) => {

        data.isApplicationUser = data.isApplicationUser == "Y";
        data.isPrimaryContact = data.isPrimaryContact == "Y";
        data.sendNotifications = data.sendNotifications == "Y";

        if (data.role) {
          const filteredRoleValue = this.roleDropdown.find((item: any) => item.valueExp == data.role);
          if (filteredRoleValue) {
            this.isRoleOdd = null;
            this.selectedRole = filteredRoleValue.valueExp;

          } else {
            this.isRoleOdd = this.selectedRole = data.role;
            this.roleDropdown.push({
              valueExp: data.role,
              displayExp: data.role
            });
          }
        }

        this.qmsAuParticipantsFieldData = data;
        this.isProcessing = false;
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      })
    }
  }

  deletingParticipantId: any;
  openDeletePopup(auParticipantEditingData: any) {
    this.operationFlag = 'DELETE';
    this.popupTitle = "Delete Audit Participants";
    this.deletingParticipantId = auParticipantEditingData.PARTICIPANT_ID;
    this.qmsAuParticipantsFieldData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  roleFieldValue: any;
  participantNameFieldValue: any;
  fieldValidation() {
    this.roleFieldValue = document.getElementById('role-validation') as HTMLInputElement;
    this.participantNameFieldValue = document.getElementById('participantName-validation') as HTMLInputElement;

    if (this.selectedRole == null) {
      this.roleFieldValue.style.color = 'red';
    } else {
      this.roleFieldValue.style.color = '';
    }

    if (this.qmsAuParticipantsFieldData.participantName == '' || this.qmsAuParticipantsFieldData.participantName == undefined) {
      this.participantNameFieldValue.style.color = 'red';
    } else {
      this.participantNameFieldValue.style.color = '';
    }
  }

  onFieldFocusout() {
    if (this.participantNameFieldValue != undefined) {
      if (this.qmsAuParticipantsFieldData.participantName == "" || this.qmsAuParticipantsFieldData.participantName == undefined) {
        this.participantNameFieldValue.style.color = 'red';
      } else {
        this.participantNameFieldValue.style.color = '';
      }
    }

    if (this.deleteReasonfieldValidation != undefined) {
      if (this.qmsAuParticipantsFieldData.deleteReason == "" || this.qmsAuParticipantsFieldData.deleteReason == undefined) {
        this.deleteReasonfieldValidation.style.color = 'red';
      } else {
        this.deleteReasonfieldValidation.style.color = '';
      }
    }
  }

  addAndEditFunction(qmsAuParticipantsFieldData: any) {
    this.isProcessing = true;
    if (this.selectedRole == null || qmsAuParticipantsFieldData.participantName == "") {
      this.fieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else {

      let data = {
        auNo: this.message.activityId,
        role: this.selectedRole ?? null,
        participantName: qmsAuParticipantsFieldData.participantName,
        applicationUserId: qmsAuParticipantsFieldData.applicationUserId,
        isApplicationUser: qmsAuParticipantsFieldData.isApplicationUser ? "Y" : "N",
        emailAddress: qmsAuParticipantsFieldData.emailAddress,
        isPrimaryContact: qmsAuParticipantsFieldData.isPrimaryContact ? "Y" : "N",
        contactDetails: qmsAuParticipantsFieldData.contactDetails,
        sendNotifications: qmsAuParticipantsFieldData.sendNotifications ? "Y" : "N",
      }



      if (this.operationFlag == 'ADD') {
        this.appService.createQmsAuParticipant(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        delete qmsAuParticipantsFieldData.createdOn;
        delete qmsAuParticipantsFieldData.updatedOn;

        const modifiedData = {
          ...data,
          participantId: this.editingParticipantId
        }

        this.appService.updateQmsAuParticipant(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteReasonfieldValidation: any;
  deleteFunction(qmsAuParticipantsFieldData: any) {
    if (this.qmsAuParticipantsFieldData.deleteReason) {
      this.isProcessing = true;
      let data = {
        participantId: this.deletingParticipantId,
        deleteReason: qmsAuParticipantsFieldData.deleteReason
      }
      this.appService.deleteQmsAuParticipant(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.deleteReasonfieldValidation = document.getElementById('delete-reason-validation') as HTMLInputElement;
      this.deleteReasonfieldValidation.style.color = 'red';
      alert('Please enter the all mandatory fields...');
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, participants: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : participants.PARTICIPANT_ID;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'AU_PARTICIPANTS';
    this.auditTrail.report_And_Popup_Name = this.qmsservice.moduleName + ' Participants Audit Trail [' + this.qmsservice.activity.auId + ']';
    this.dynamicAuditTrailComponent.triggerTrail(participants);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' Participants Report [' + this.qmsservice.activity.auId + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  public focusEmpty(): void {
    console.log();
  }
}
